import { CallMeAction } from './call.me.types'
export const callMeRequestAction = (params: { name: string; phone: string | number }): CallMeAction => ({ type: 'CALL_ME_REQUEST', params })
export const callMeSuccessAction = (): CallMeAction => ({ type: 'CALL_ME_SUCCESS' })
export const callMeFailureAction = (error?: any): CallMeAction => ({ type: 'CALL_ME_FAILURE', params: error })